import { api, ERR_OK } from './config';
import axios from 'axios';

/**
 * 获取学生列表
 * @param userId
 * @param pageIndex
 * @param status
 * @param stuPhone
 * @param schoolId
 * @param insNo
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getStudentList(userId, pageIndex, status, stuPhone, schoolId, insNo) {
  return await axios.post(api.studentListUrl, {
    userId,
    pageIndex,
    status,
    stuPhone,
    schoolId,
    insNo,
  }).then((res) => {
    if (res.data.rspCode === ERR_OK) {
      return res.data;
    } else {
      return [];
    }
  });
}

/**
 * 获取学生信息详情
 * @param userId
 * @param courseStockDetailId
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getStudentDetail(userId, courseStockDetailId) {
  return await axios.post(api.studentDetailUrl, {
    userId,
    courseStockDetailId,
  }).then((res) => {
    return res.data;
  });
}